var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPanel',{attrs:{"mode":"processed","fetch-list":_vm.fetchDoneList}})
}
var staticRenderFns = []

export { render, staticRenderFns }